import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { GoogleOAuthProvider } from '@react-oauth/google';

ReactDOM.render(
  // PRODUCTION DEPLOYMENT
  <GoogleOAuthProvider clientId="731322513845-74ha25rk8vklfshmuo3pmd6o43cu6eeo.apps.googleusercontent.com">
  {/* </GoogleOAuthProvider><GoogleOAuthProvider clientId="639312189237-j1g08977p977c04e2rp5e7fvn63hnleh.apps.googleusercontent.com"> */}
    <Provider store={store}>
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    </Provider>
  </GoogleOAuthProvider>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
